import React, { useState } from 'react';

// functions
import { useToggle } from 'shared/functions';

// components
import { Hero } from 'shared/components/bulma/hero';
import { Button } from 'shared/components/bulma/button';
import { ModalReport } from 'shared/components/product';
import { TableProductDamage } from './table-product-damage';


const ProductDamage = () => {
    const [modal, setModal] = useToggle();
    const [lastBarcode, setLastBarcode] = useState();

    const Modal = () => {
        if (!modal) {
            return null;
        }

        return (
            <ModalReport modal={modal} handleModal={setModal} setLastBarcode={setLastBarcode} />
        )
    }

    return (
        <>
            <div className="columns is-gapless">
                <div className="column is-1 is-hidden-mobile">
                    <Hero className="is-fullheight hero-damage-pattern" />
                </div>
                <div className="column">
                    <section className="section is-small">
                        <div className="field is-grouped">
                            <div className="control">
                                <Button className="is-info" name="report" onClick={setModal}>
                                    Report
                                </Button>
                            </div>
                        </div>
                    </section>
                    <section className="section is-small">
                        <TableProductDamage lastBarcode={lastBarcode} />
                    </section>
                </div >
            </div>

            <Modal />
        </>
    );
};

export { ProductDamage };
